export default "__VITE_ASSET__DWbTkju6__"